import { memo, useContext, useMemo } from "react";
import ImportComponent from "./ImportComponent";
import { IJsonArr, downloadCSV } from "src/utils/utils";
import { errorNotification } from "src/utils/alerts";
import { MESSAGES, MigrationModalStyle } from "src/utils/constants";
import {
  InternalSubscriptionsInput,
  PaymentFrequency,
  SubscriptionJsonArrInput,
  useGetAgreementManyQuery,
  useMigrateSubscriptionMutation,
  useSubscriptionSampleCsvLazyQuery,
} from "src/generated/graphql";
import { migrateErrors } from "./migrateMessage";
import RelationMapping, { IDereferenceField } from "./RelationMapping";
import { closeAllModals, openModal } from "@mantine/modals";
import { AppContext } from "src/api/AppContext";

type ISubscriptionImports = {
  locId: string;
};

function SubscriptionImports({ locId }: ISubscriptionImports) {
  const [getSampleCsv, { loading: isCsvDownloading }] =
    useSubscriptionSampleCsvLazyQuery();

  const [migrateSubscriptions, { loading: uploadloading }] =
    useMigrateSubscriptionMutation();

  const { data: agreementData, loading: agreementLoading } =
    useGetAgreementManyQuery({
      onCompleted() {},
      variables: {
        locationIds: [{ id: locId }],
      },
      skip: !locId,
      fetchPolicy: "network-only",
    });
  const isDisabled = !agreementData?.agreementMany?.length;

  const fields: IDereferenceField[] = useMemo(
    () => [
      {
        csvColumnHeader: "Subscription Name",
        fieldName: "SubscriptionName",
        required: true,
        options:
          agreementData?.agreementMany?.map((e) => ({
            value: e.id,
            label: e.name,
          })) || [],
      },
      {
        csvColumnHeader: "Cycle Duration",
        fieldName: "CycleDuration",
        required: true,
        options:
          Object.keys(PaymentFrequency).map((e) => ({
            value: e,
            label: e,
          })) || [],
      },
    ],
    [agreementData]
  );

  const onUpload = async (jsonArr: IJsonArr) => {
    try {
      const subscriptionJsonArrInput: SubscriptionJsonArrInput = {
        data: jsonArr as InternalSubscriptionsInput[],
      };

      const openModalSelect = () => {
        const onSubmit = async () => {
          try {
            console.log(subscriptionJsonArrInput, "<--");
            closeAllModals();
            const { data } = await migrateSubscriptions({
              variables: { data: subscriptionJsonArrInput, locationId: locId },
            });
            data && migrateErrors(data.migrateSubscription.errors);
          } catch (err) {
            errorNotification({ message: MESSAGES.INVALID_CSV });
          }
        };

        openModal({
          ...MigrationModalStyle,
          closeOnClickOutside: false,
          title: "Subscription Mapping",
          children: (
            <RelationMapping
              csvData={jsonArr}
              onSubmit={onSubmit}
              fields={fields}
            />
          ),
        });
      };
      openModalSelect();
    } catch (err) {
      errorNotification({ message: MESSAGES.INVALID_CSV });
    }
  };

  const onDownload = async () => {
    const { data } = await getSampleCsv();
    downloadCSV(data?.subscriptionSampleCSV, "Subscription_Sample.csv");
  };
  return (
    <>
      <ImportComponent
        title="Step 5 - Subscription"
        onDownload={onDownload}
        onUpload={onUpload}
        loading={isCsvDownloading}
        uploadloading={uploadloading}
        disabled={isDisabled}
        bannerContent={
          isDisabled && !agreementLoading ? "Requires at least 1 Agreement" : ""
        }
      />
    </>
  );
}

export default memo(SubscriptionImports);
